"use client"
import moment from "moment"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { createApplication, updateApplication, clearSuccess } from "../../../redux/features/applicationSlice"
import { setApplicationData } from "../../../redux/features/newApplicationSlice"
import { Country, City, State } from 'country-state-city';
import { CustomSelect } from "../../common/CustomSelect";
function getCitiesByCountry(countryName) {
  const country = Country.getAllCountries().find(
    (c) => c.name.toLowerCase() === countryName.toLowerCase(),
  );

  if (!country) return [];

  const states = State.getStatesOfCountry(country.isoCode);

  let cities = [];

  states.forEach((state) => {
    const stateCities = City.getCitiesOfState(country.isoCode, state.isoCode);
    cities = [...cities, ...stateCities];
  });

  return cities.map((c) => c.name);
}
export default function ApplicationForm({ propsData, allow, setActiveTab, onRefresh }) {
  const FIELD_LIMITS = {
    firstName: 100,
    lastName: 100,
    passportNumber: 20,
    children: 2,
    address: 120,
    city: 60,
    country: 60,
    zipcode: 12,
    mobileNumber: 15,
    email: 100,
    secondaryEmail: 100,
    qualifications: 80,
    yearOfCompletion: 4,
    jobTitle: 60,
    countryOfInterest: 60,
    cityOfInterest: 60,
    universityName: 100,
    emailByWCC: 100,
    USI: 20,
    emergencyContactName: 60,
    emergencyContactRelationship: 40,
    emergencyContactNumber: 15,
    familyInfo: 100,
    biometricProcessCity: 60,
    agentReference: 50,
  }

  const clampValue = (value, maxLength) => {
    if (typeof value !== "string") return value
    if (!maxLength) return value
    return value.slice(0, maxLength)
  }

  const sanitizeFieldValue = (field, value) => {
    if (typeof value !== "string") return value

    let sanitized = value

    if (
      [
        "firstName",
        "lastName",
        "universityName",
        "city",
        "country",
        "countryOfInterest",
        "cityOfInterest",
        "emergencyContactName",
        "emergencyContactRelationship",
        "biometricProcessCity",
      ].includes(field)
    ) {
      sanitized = sanitized.replace(/[^a-zA-Z\s'-]/g, "")
    }

    if (
      [
        "zipcode",


        "children",
        "yearOfCompletion",
      ].includes(field)
    ) {
sanitized = sanitized.replace(/\D/g, "")
    }
    if(field === "mobileNumber" || field === "emergencyContactNumber"){
      sanitized = sanitized.replace(/[^0-9+]/g, "")
      const plusCount = (sanitized.match(/\+/g) || []).length
      if (plusCount > 1) {
        sanitized = sanitized.replace(/\+/g, "")
      } else if (plusCount === 1) {
        sanitized = '+' + sanitized.replace(/\+/g, '')
      }
    }
 if (field === 'passportNumber') {
      sanitized = sanitized.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    }
    if(field==="jobTitle"){
      sanitized = sanitized.replace(/[^a-zA-Z\-\s,.()']/g, "")


}
    if (field === "USI") {
      sanitized = sanitized.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    }

    if (field === "familyInfo") {
      sanitized = sanitized.replace(/[^a-zA-Z\-\s,()']/g, "")
    }

    return clampValue(sanitized, FIELD_LIMITS[field])
  }

  const normalizeFormData = (data) => {
    return Object.keys(data).reduce((acc, key) => {
      acc[key] = sanitizeFieldValue(key, data[key])
      return acc
    }, {})
  }

  const { id } = useParams()
  const idFromParams = id
  const dispatch = useDispatch()
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const [cities, setCities] = useState([])
  const [processTypes, setProcessTypes] = useState([])
  // const [savedApplication, setSavedApplication] = useState(false);
  const { success } = useSelector((state) => state.application)
  const newData = useSelector((state) => state.createApplication.newData)
  const [isSavingProgress, setIsSavingProgress] = useState(false)

  const defaultFormData = {
    processType: "",
    biometricProcessDate: "",
    biometricProcessCity: "",
    firstName: "",
    lastName: "",
    dob: "",
    passportNumber: "",
    passportExpiry: "",
    visaExpiryDate: "",
    emailByWCC: "",
    USI: "",
    gender: "",
    age: "",
    maritalStatus: "",
    children: "",
    employmentType: "",
    jobTitle: "",
    emergencyContactName: "",
    emergencyContactRelationship: "",
    emergencyContactNumber: "",
    countryOfInterest: "",
    cityOfInterest: "",
    universityName: "",
    address: "",
    city: "",
    country: "",
    zipcode: "",
    email: "",
    secondaryEmail: "",
    mobileNumber: "",
    familyInfo: "",
    inquiryType: "",
    visaCategory: "",
    qualifications: "",
    yearOfCompletion: "",
    institution: "",
    institutionLocation: "",
    status: "In-Progress",
    userId: "",
    assignAgent: "",
    agentReference: ""
  }

  const [formData, setFormData] = useState({ ...defaultFormData })

  const updateField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: sanitizeFieldValue(field, value),
    }))
  }

  const handleNumericKeyDown = (e) => {

    if (["e", "E", "-", "."].includes(e.key)) {
      e.preventDefault()
    }
  }

  const handleAlphabetKeyDown = (e) => {
    const allowedControlKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Home",
      "End",
    ]

    if (allowedControlKeys.includes(e.key)) {
      return
    }

    if (
      (e.ctrlKey || e.metaKey) &&
      ["a", "c", "v", "x"].includes(e.key.toLowerCase())
    ) {
      return
    }

    if (e.key === " ") {
      return
    }

    if (!/^[a-zA-Z]$/.test(e.key)) {
      e.preventDefault()
    }
  }

  const handleRelationKeyDown = (e) => {
    const allowedControlKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Home",
      "End",
    ]

    if (allowedControlKeys.includes(e.key)) {
      return
    }

    if (
      (e.ctrlKey || e.metaKey) &&
      ["a", "c", "v", "x"].includes(e.key.toLowerCase())
    ) {
      return
    }

    if (e.key === " " || e.key === "-" || e.key === "'") {
      return
    }

    if (!/^[a-zA-Z]$/.test(e.key)) {
      e.preventDefault()
    }
  }

  const handleInputChange = (e, field) => {
    updateField(field, e.target.value)
  }

  const clearForm = () => {
    setFormData({ ...defaultFormData })
  }

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        dispatch(clearSuccess())
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [success, dispatch])

  useEffect(() => {
    // setSavedApplication(false);
    if (propsData?.id === "new") {
      setFormData((prev) => ({
        ...prev,
        firstName: propsData?.firstName || "",
        lastName: propsData?.lastName || "",
        countryOfInterest: propsData?.countryOfInterest || "",
        country: propsData?.country || "",
        email: propsData?.email || "",
        mobileNumber: propsData?.phone || "",
        visaCategory: propsData?.visaCategory || "",
        status: "In-Progress",
      }))
    } else {
      setFormData({
        processType: propsData?.processType || "",
        biometricProcessDate: propsData?.biometricProcessDate
          ? moment(propsData.biometricProcessDate).format("YYYY-MM-DD")
          : "",
        biometricProcessCity: propsData?.biometricProcessCity || "",
        firstName: propsData?.firstName || "",
        lastName: propsData?.lastName || "",
        dob: propsData?.dob ? moment(propsData.dob).format("YYYY-MM-DD") : "",
        passportNumber: propsData?.passportNumber || "",
        passportExpiry: propsData?.passportExpiry ? moment(propsData.passportExpiry).format("YYYY-MM-DD") : "",
        visaExpiryDate: propsData?.visaExpiryDate ? moment(propsData.visaExpiryDate).format("YYYY-MM-DD") : "",
        emailByWCC: propsData?.emailByWCC || "",
        USI: propsData?.USI || "",
        gender: propsData?.gender || "",
        // Remove age from here as we'll calculate it from DOB
        age: "",
        maritalStatus: propsData?.maritalStatus || "",
        children: propsData?.children || "",
        employmentType: propsData?.employmentType || "",
        jobTitle: propsData?.jobTitle || "",
        emergencyContactName: propsData?.emergencyContactName || "",
        emergencyContactRelationship: propsData?.emergencyContactRelationship || "",
        emergencyContactNumber: propsData?.emergencyContactNumber || "",
        countryOfInterest: propsData?.countryOfInterest || "",
        cityOfInterest: propsData?.cityOfInterest || "",
        universityName: propsData?.universityName || "",
        address: propsData?.address || "",
        city: propsData?.city || "",
        country: propsData?.country || "",
        zipcode: propsData?.zipcode || "",
        email: propsData?.email || "",
        secondaryEmail: propsData?.secondaryEmail || "",
        mobileNumber: propsData?.mobileNumber || "",
        familyInfo: propsData?.familyInfo || "",
        inquiryType: propsData?.inquiryType || "",
        visaCategory: propsData?.visaCategory || "",
        qualifications: propsData?.qualifications || "",
        yearOfCompletion: propsData?.yearOfCompletion || "",
        institution: propsData?.institution || "",
        institutionLocation: propsData?.institutionLocation || "",
        status: propsData?.status || "In-Progress",
        userId: propsData?.userId || "",
        assignAgent: propsData?.agent || "", // Added assignAgent to setFormData
        agentReference: propsData?.agentReference || '',

      })
    }
  }, [propsData])

  useEffect(() => {
    if (formData.dob) {
      const birthDate = new Date(formData.dob)
      const today = new Date()
      let age = today.getFullYear() - birthDate.getFullYear()
      const monthDifference = today.getMonth() - birthDate.getMonth()

      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }

      setFormData((prevData) => ({
        ...prevData,
        age: age.toString(),
      }))
    }
  }, [formData.dob])

  // Create application
  const createApp = async () => {
    try {
      // Use the exact variable names provided
      const normalizedData = normalizeFormData(formData)

      const apiFormData = {
        processType: normalizedData.processType,
        biometricProcessCity: normalizedData.biometricProcessCity,
        biometricProcessDate: normalizedData.biometricProcessDate,
        firstName: normalizedData.firstName?.trim(),
        lastName: normalizedData.lastName?.trim(),
        dob: normalizedData.dob,
        passportNumber: normalizedData.passportNumber,
        passportExpiry: normalizedData.passportExpiry,
        visaExpiryDate: normalizedData.visaExpiryDate,
        emailByWCC: normalizedData.emailByWCC,
        USI: normalizedData.USI,
        gender: normalizedData.gender,
        age: normalizedData.age,
        maritalStatus: normalizedData.maritalStatus,
        children: normalizedData.children,
        employmentType: normalizedData.employmentType,
        jobTitle: normalizedData.jobTitle,
        emergencyContactName: normalizedData.emergencyContactName,
        emergencyContactRelationship: normalizedData.emergencyContactRelationship,
        emergencyContactNumber: normalizedData.emergencyContactNumber,
        countryOfInterest: normalizedData.countryOfInterest,
        cityOfInterest: normalizedData.cityOfInterest,
        universityName: normalizedData.universityName,
        address: normalizedData.address,
        city: normalizedData.city,
        country: normalizedData.country,
        zipcode: normalizedData.zipcode,
        email: normalizedData.email,
        secondaryEmail: normalizedData.secondaryEmail,
        mobileNumber: normalizedData.mobileNumber,
        familyInfo: normalizedData.familyInfo,
        inquiryType: normalizedData.inquiryType,
        visaCategory: normalizedData.visaCategory,
        qualifications: normalizedData.qualifications,
        yearOfCompletion: normalizedData.yearOfCompletion,
        institution: normalizedData.institution,
        institutionLocation: normalizedData.institutionLocation,
        status: normalizedData.status,
        userId: normalizedData.userId,
        assignAgent: normalizedData.assignAgent, // Added assignAgent to apiFormData
        agentReference: normalizedData.agentReference,
      }

      const response = await dispatch(createApplication({ formData: apiFormData })).unwrap()
      const createdApplication = response?.body?.application

      if (createdApplication?._id && typeof onRefresh === "function") {
        onRefresh(createdApplication)
      }

      const newAppId = response.body.application._id

      dispatch(
        setApplicationData({
          countryOfInterest: newData.countryOfInterest,
          visaCategory: newData.visaCategory,
          id: newAppId,
          status: newData.status,
          applicationID: newAppId,
        }),
      )
      navigate("/client/applications/form/" + response.body.application._id)
      console.log(newData)
    } catch (err) {
      console.error("API Error:", err)
      setError(err)
    }
  }

  // Update application
  const updateApp = async (id) => {
    try {
      // Use the exact variable names provided
      const normalizedData = normalizeFormData(formData)

      const apiFormData = Object.fromEntries(
        Object.entries({
          processType: normalizedData.processType,
          biometricProcessCity: normalizedData.biometricProcessCity,
          biometricProcessDate: normalizedData.biometricProcessDate,
          firstName: normalizedData?.firstName?.trim(),
          lastName: normalizedData?.lastName?.trim(),
          dob: normalizedData.dob,
          passportNumber: normalizedData.passportNumber,
          passportExpiry: normalizedData.passportExpiry,
          visaExpiryDate: normalizedData.visaExpiryDate,
          emailByWCC: normalizedData.emailByWCC,
          USI: normalizedData.USI,
          gender: normalizedData.gender,
          age: normalizedData.age,
          maritalStatus: normalizedData.maritalStatus,
          children: normalizedData.children,
          employmentType: normalizedData.employmentType,
          jobTitle: normalizedData.jobTitle,
          emergencyContactName: normalizedData.emergencyContactName,
          emergencyContactRelationship: normalizedData.emergencyContactRelationship,
          emergencyContactNumber: normalizedData.emergencyContactNumber,
          countryOfInterest: normalizedData.countryOfInterest,
          cityOfInterest: normalizedData.cityOfInterest,
          universityName: normalizedData.universityName,
          address: normalizedData.address,
          city: normalizedData.city,
          country: normalizedData.country,
          zipcode: normalizedData.zipcode,
          email: normalizedData.email,
          secondaryEmail: normalizedData.secondaryEmail,
          mobileNumber: normalizedData.mobileNumber,
          familyInfo: normalizedData.familyInfo,
          inquiryType: normalizedData.inquiryType,
          visaCategory: normalizedData.visaCategory,
          qualifications: normalizedData.qualifications,
          yearOfCompletion: normalizedData.yearOfCompletion,
          institution: normalizedData.institution,
          institutionLocation: normalizedData.institutionLocation,
          status: normalizedData.status,
          userId: normalizedData.userId,
          agentReference: normalizedData.agentReference,
          // assignAgent: formData.assignAgent, // Added assignAgent
        }).filter(([_, value]) => value !== undefined && value !== ""),
      )

      const updateResult = await dispatch(
        updateApplication({ id, formData: apiFormData }),
      ).unwrap()

      const updatedApplication = updateResult?.data?.body
      if (updatedApplication?._id && typeof onRefresh === "function") {
        onRefresh(updatedApplication)
      }
    } catch (err) {
      console.error("API Error:", err)
      setError(err)
      throw err
    }
  }

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault()
    // setSavedApplication(true);
    setError(null)
    setIsSavingProgress(true)

    try {
      if (newData.id === "new" && idFromParams === "new") {
        await createApp()
      } else {
        const appId = newData.id !== "new" && newData.id !== "" ? newData.id : idFromParams
        await updateApp(appId)
      }
    } finally {
      setIsSavingProgress(false)
    }
  }

  useEffect(() => {
    // const fetchCities = async () => {
    //   if (propsData?.countryOfInterest) {
    //     try {
    //       const response = await fetch(
    //         `${process.env.REACT_APP_API_BASE_URL}/api/user/getCities/${propsData?.countryOfInterest}`,
    //       )
    //       if (!response.ok) {
    //         throw new Error("Failed to fetch cities")
    //       }
    //       const data = await response.json()
    //       // console.log(data);
    //       setCities(data.body)
    //     } catch (error) {
    //       console.error("Error fetching cities:", error)
    //     }
    //   }
    // }
    const fetchCities = async () => {
      try {
        let cities = getCitiesByCountry(propsData?.countryOfInterest);
        setCities(cities);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };
    fetchCities()
  }, [propsData?.countryOfInterest])

  useEffect(() => {
    const fetchProcessTypes = async () => {
      try {
        const token = localStorage.getItem("token")
        if (!token) {
          setProcessTypes([])
          return
        }

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/processtype`, {
          method: "GET",
          headers: {
            authorization: `bearer ${token}`,
          },
        })

        const data = await response.json()
        setProcessTypes(data?.body?.processTypes || [])
      } catch (error) {
        console.error("Error fetching process types:", error)
        setProcessTypes([])
      }
    }

    fetchProcessTypes()
  }, [])

  return (
    <form
      onSubmit={handleSubmit}
      className="p-4 md:p-6 rounded-lg rounded-tl-none shadow-sm bg-[#FFFBF5] border border-[#CAC3BB] text-sm md:text-base"
    >
      <div onClick={() => console.log(newData)} className="mb-6">
        <h1 className="text-xl font-medium text-gray-900">Application Details</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-9 gap-y-6">
        {/* Left Column */}
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">First Name</label>
              <input
                type="text"
                value={formData.firstName}
                onChange={(e) => handleInputChange(e, "firstName")}
                className="w-full p-2 border rounded-md text-gray-700"
                placeholder="Enter first name"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Last Name</label>
              <input
                type="text"
                value={formData.lastName}
                onChange={(e) => handleInputChange(e, "lastName")}
                className="w-full p-2 border rounded-md text-gray-700"
                placeholder="Enter last name"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
          </div>

          {/* <div className="space-y-2">
            <label className="block font-medium text-gray-700">Passport Number</label>
            <input
              type="text"
              value={formData.passportNumber}
              onChange={(e) => setFormData({ ...formData, passportNumber: e.target.value })}
              className="w-full p-2 border rounded-md text-gray-700"
              placeholder="Enter passport number"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Passport Expiry Date</label>
            <input
              type="date"
              value={formData.passportExpiry}
              onChange={(e) => setFormData({ ...formData, passportExpiry: e.target.value })}
              className="w-full p-2 border rounded-md text-gray-700"
              aria-label="Passport Expiry Date"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div> */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Passport Number
              </label>
              <input
                type="text"
                inputMode="text"
                pattern="[A-Z0-9]*"

                value={formData.passportNumber}
                onChange={(e) => handleInputChange(e, "passportNumber")}
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
                className={`mt-1 w-full p-2 border rounded-md ${(propsData.status !== "Withdrawn" && propsData.status !== "Finalized") ? 'bg-white' : ''}`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Passport Expiry Date
              </label>
              <div className="mt-1 relative">
                <input
                  type="date"
                  value={formData.passportExpiry}
                  onChange={(e) => setFormData({ ...formData, passportExpiry: e.target.value })}
                  disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
                  className={`w-full p-2 border rounded-md ${(propsData.status !== "Withdrawn" && propsData.status !== "Finalized") ? 'bg-white' : ''}`}
                />
                {/* <LuCalendar1 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 h-4 w-4" /> */}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Visa Expiry Date
              </label>
              <div className="mt-1 relative">
                <input
                  type="date"
                  value={formData.visaExpiryDate}
                  onChange={(e) => setFormData({ ...formData, visaExpiryDate: e.target.value })}
                  disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
                  className={`w-full p-2 border rounded-md ${(propsData.status !== "Withdrawn" && propsData.status !== "Finalized") ? 'bg-white' : ''}`}
                />
                {/* <LuCalendar1 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 h-4 w-4" /> */}
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Date of Birth
              </label>
              <div className="mt-1 relative">
                <input
                  type="date"
                  value={formData.dob}
                  onChange={(e) => setFormData({ ...formData, dob: e.target.value })}
                  className="w-full p-2 border rounded-md text-gray-700"
                  aria-label="Date of Birth"
                  max={new Date().toISOString().split("T")[0]}
                  disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
                />
                {/* <LuCalendar1 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 h-4 w-4" /> */}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Gender</label>
              <select
                value={formData.gender}
                onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
                className="w-full p-2 border rounded-md text-gray-700 bg-white"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              >
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Not prefer to say">Not prefer to say</option>
              </select>
            </div>
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Age</label>
              <input
                type="number"
                value={formData?.age}
                readOnly
                className="w-full p-2 border rounded-md text-gray-700 appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none bg-gray-100"
                placeholder="Auto-calculated from DOB"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Marital Status</label>
              <select
                value={formData.maritalStatus}
                onChange={(e) => setFormData({ ...formData, maritalStatus: e.target.value })}
                className="w-full p-2 border rounded-md text-gray-700 bg-white"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              >
                <option value="">Select</option>
                <option value="single">Single</option>
                <option value="married">Married</option>
                <option value="divorced">Divorced</option>
                <option value="widowed">Widowed</option>
              </select>
            </div>
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Children</label>
              <input
                type="text"
                value={formData.children}
                onChange={(e) => handleInputChange(e, "children")}
                className="w-full p-2 border rounded-md text-gray-700"
                placeholder="Enter number of children"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Address</label>
            <input
              type="text"
              value={formData.address}
              onChange={(e) => handleInputChange(e, "address")}
              className="w-full p-2 border rounded-md text-gray-700"
              placeholder="Enter complete address"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Country</label>
              <input
                type="text"
                value={formData.country}
                onChange={(e) => handleInputChange(e, "country")}
                className="w-full p-2 border rounded-md text-gray-700"
                placeholder="Enter country"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">City</label>
              <input
                type="text"
                value={formData.city}
                onChange={(e) => handleInputChange(e, "city")}
                className="w-full p-2 border rounded-md text-gray-700"
                placeholder="Enter city"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Zip Code</label>
              <input
                type="text"
                value={formData.zipcode}
                onChange={(e) => handleInputChange(e, "zipcode")}
                className="w-full p-2 border rounded-md text-gray-700"
                placeholder="Enter zip code"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Mobile No.</label>
              <input
                type="text"
                inputMode="tel"
                pattern="[0-9+]*"
                value={formData.mobileNumber}
                onChange={(e) => handleInputChange(e, "mobileNumber")}
                onKeyDown={handleNumericKeyDown}
                className="w-full p-2 border rounded-md text-gray-700"
                placeholder="Enter mobile number"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
          </div>

          {/* <div className="space-y-2">
            <label className="block font-medium text-gray-700">Email Address</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="w-full p-2 border rounded-md text-gray-700"
              placeholder="Enter email address"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div> */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Primary Email Address
              </label>
              <input
                type="email"
                value={formData.secondaryEmail}
                onChange={(e) => handleInputChange(e, "secondaryEmail")}
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
                className={`mt-1 w-full p-2 border rounded-md ${(propsData.status !== "Withdrawn" && propsData.status !== "Finalized") ? 'bg-white' : ''}`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Secondary Email Address
              </label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => handleInputChange(e, "email")}
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
                className={`mt-1 w-full p-2 border rounded-md ${(propsData.status !== "Withdrawn" && propsData.status !== "Finalized") ? 'bg-white' : ''}`}
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Qualification</label>
            <input
              type="text"
              value={formData.qualifications}
              onChange={(e) => handleInputChange(e, "qualifications")}
              className="w-full p-2 border rounded-md text-gray-700"
              placeholder="Enter qualifications"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Year of completion</label>
            <input
              type="text"
                value={formData.yearOfCompletion}
                onChange={(e) => handleInputChange(e, 'yearOfCompletion')}
              className="w-full p-2 border rounded-md text-gray-700 appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
              placeholder="Enter year"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div className="md:space-y-2">
              <label className="block font-medium text-gray-700 pb-2 md:pb-0">
                Employment Type <span className="text-red-500 text-xl">*</span>
              </label>
              <select
                value={formData.employmentType}
                onChange={(e) => setFormData({ ...formData, employmentType: e.target.value })}
                className="w-full p-2 border rounded-md text-gray-700 bg-white"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              >
                <option value="">Select</option>
                <option value="Unemployed">Unemployed</option>
                <option value="Full-time">Full-time</option>
                <option value="Part-time">Part-time</option>
                <option value="Contract">Contract</option>
                <option value="Internship">Internship</option>
                <option value="Freelance">Freelance</option>
              </select>
            </div>
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Job Title</label>
              <input
                type="text"
                value={formData.jobTitle}
                onChange={(e) => handleInputChange(e, "jobTitle")}
                className="w-full p-2 border rounded-md text-gray-700"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-4">
          <div className="grid md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Country of Interest</label>
              <input
                type="text"
                readOnly
                value={formData.countryOfInterest}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    countryOfInterest: e.target.value,
                  })
                }
                className="w-full p-2 border rounded-md text-gray-700"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
            <div className="space-y-2">
              <label
                // onClick={() => console.log(cities)}
                className="block font-medium text-gray-700"
              >
                Destination City
              </label>
              <CustomSelect
                options={cities}
                value={formData.cityOfInterest}
                onChange={(val) => updateField("cityOfInterest", val)}
                placeholder="Select"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              University Name
            </label>
            <input
              type="text"
              value={formData.universityName}
              onChange={(e) => handleInputChange(e, "universityName")}
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              className={`mt-1 w-full p-2 border rounded-md ${propsData.status === "Withdrawn" || propsData.status === "Finalized" ? 'bg-gray-200' : 'bg-white'}`}
            />
          </div>
          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Email by WCC</label>
            <input
              type="email"
              value={formData.emailByWCC}
              onChange={(e) => handleInputChange(e, "emailByWCC")}
              className="w-full p-2 border rounded-md text-gray-700"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Unique Student Identifier (USI)</label>
            <input
              type="text"
              inputMode="text"
                pattern="[A-Z0-9]*"
              maxLength={FIELD_LIMITS.USI}
              value={formData.USI}
              onChange={(e) => handleInputChange(e, "USI")}
              className="w-full p-2 border rounded-md text-gray-700"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Emergency Contact Name</label>
              <input
                type="text"
                placeholder="Name"
                value={formData.emergencyContactName}
                onChange={(e) => handleInputChange(e, "emergencyContactName")}
                className="w-full p-2 border rounded-md text-gray-700"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Relation</label>
              <input
                type="text"
                placeholder="Relation"
                value={formData.emergencyContactRelationship}
                onChange={(e) => handleInputChange(e, "emergencyContactRelationship")}
                onKeyDown={handleRelationKeyDown}
                className="w-full p-2 border rounded-md text-gray-700"
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Emergency Contact Number</label>
            <input
              type="text"
              inputMode="tel"
              pattern="[0-9+]*"
              placeholder="Enter number here"
              value={formData.emergencyContactNumber}
              onChange={(e) => handleInputChange(e, "emergencyContactNumber")}
              onKeyDown={handleNumericKeyDown}
              className="w-full p-2 border rounded-md text-gray-700 appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Pending Info</label>
            <textarea
              value={formData.familyInfo}
              onChange={(e) => handleInputChange(e, "familyInfo")}
              className="w-full p-2 border rounded-md text-gray-700 min-h-[120px] resize-y"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Process Type
            </label>
            <select
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              value={formData.processType?._id || formData.processType || ""}
              onChange={(e) => setFormData({ ...formData, processType: e.target.value })}
              className={`mt-1 w-full p-2 border rounded-md ${(propsData.status !== "Withdrawn" && propsData.status !== "Finalized") ? 'bg-white' : ''}`}
            >
              <option value="">Select</option>
              {processTypes?.map((eachProcessType) => (
                <option
                  key={eachProcessType?._id}
                  value={eachProcessType?._id.toString()}
                >
                  {eachProcessType?.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <div className="mb-2 block font-medium text-gray-700">Biometric Appointment</div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Date
                </label>
                <div className="mt-1 relative">
                  <input
                    type="date"
                    value={formData.biometricProcessDate}
                    onChange={(e) =>
                      setFormData({ ...formData, biometricProcessDate: e.target.value })
                    }
                    disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
                    className={`w-full p-2 border rounded-md ${(propsData.status !== "Withdrawn" && propsData.status !== "Finalized") ? 'bg-white' : ''}`}
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  City
                </label>
                <input
                  type="text"
                  value={formData.biometricProcessCity}
                  onChange={(e) => handleInputChange(e, "biometricProcessCity")}
                  disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
                  className={`mt-1 w-full p-2 border rounded-md ${(propsData.status !== "Withdrawn" && propsData.status !== "Finalized") ? 'bg-white' : ''}`}
                />
              </div>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Agent Reference
            </label>
            <input
              type="text"
              value={formData.agentReference}
              onChange={(e) => handleInputChange(e, 'agentReference')}
              className={`mt-1 w-full p-2 border rounded-md `}
            />
          </div>
          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Assign Agent(auto filled field by agent)</label>
            <input
              type="text"
              readOnly
              value={`${formData.assignAgent ? formData.assignAgent.firstName + " " + formData.assignAgent.lastName : ""
                } `}
              className="w-full p-2 border rounded-md text-gray-700"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            />
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Inquiry Type <span className="text-red-500 text-xl">*</span></label>
            <select
              value={formData.inquiryType}
              onChange={(e) => setFormData({ ...formData, inquiryType: e.target.value })}
              className="w-full p-2 border rounded-md text-gray-700 bg-white"
              disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
            >
              <option value="">Select</option>
              <option value="Walk-In">Walk-In</option>
              <option value="Call">Call</option>
              <option value="Social">Social</option>
            </select>
          </div>

          {/* {(formData.visaCategory === "Study Visa" ||
            propsData.visaCategory === "Study Visa") && (
            <>
              <div className="space-y-2">
                <label className="block font-medium text-gray-700">
                  Institute Name
                </label>
                <input
                  type="text"
                  readOnly
                  // placeholder="Enter institution name"
                  value={formData.institution}
                  // onChange={(e) =>
                  //   setFormData({ ...formData, institution: e.target.value })
                  // }
                  className="w-full p-2 border rounded-md text-gray-700"
                  disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized" }}
                />
              </div>

              <div className="space-y-2">
                <label className="block font-medium text-gray-700">
                  Program Name
                </label>
                <input
                  type="text"
                  readOnly
                  // placeholder="Enter institution location"
                  value={formData.institutionLocation}
                  // onChange={(e) =>
                  //   setFormData({ ...formData, institutionLocation: e.target.value })
                  // }
                  className="w-full p-2 border rounded-md text-gray-700"
                  disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized" }}
                />
              </div>
              <div className="space-y-2">
                <label className="block font-medium text-gray-700">
                  {" "}
                  Offer Letter Status
                </label>
                <input
                  type="text"
                  readOnly
                  // placeholder="Enter institution name"
                  value={formData.institution}
                  // onChange={(e) =>
                  //   setFormData({ ...formData, institution: e.target.value })
                  // }
                  className="w-full p-2 border rounded-md text-gray-700"
                  disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized" }}
                />
              </div>

              <div className="space-y-2">
                <label className="block font-medium text-gray-700">
                  Offer Letter Uploaded
                </label>
                <input
                  type="text"
                  readOnly
                  value={formData.institutionLocation}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      institutionLocation: e.target.value,
                    })
                  }
                  className="w-full p-2 border rounded-md text-gray-700"
                  disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized" }}
                />
              </div>
            </>
          )} */}
        </div>
      </div>

      {error && <p className="text-red-500 mt-4 text-right">{String(error)}</p>}
      {success && <p className="text-green-500 text-sm mt-2 text-right">Application saved successfully!</p>}

      <div className="flex justify-end gap-3 mt-4">
        {isSavingProgress ? (
          <button
            type="button"
            className="w-[167px] h-[40px] flex items-center justify-center bg-[#0c4a6e] text-white px-7 py-1.5 rounded-full hover:bg-[#075985] "
          >
            <span className="loader"></span>
          </button>
        ) : (
          <>
            {
              <button
                type="submit"
                className={` text-white px-7 py-1.5 rounded-full  transition-colors font-light ${propsData.status === "Withdrawn" ? "bg-[#0c4a6e5f]" : "bg-[#0c4a6e] hover:bg-[#075985]"
                  }`}
                disabled={propsData.status === "Withdrawn" || propsData.status === "Finalized"}
              >
                Save Progress
              </button>
            }
          </>
        )}

        <button
          type="button"
          onClick={() => {
            if (allow) {
              setActiveTab("documents")
            }
          }}
          className={`text-white px-8 py-2 rounded-full transition-colors ${allow ? "bg-[#0c4a6e] hover:bg-[#075985]" : "bg-gray-400 cursor-default"
            }`}
        >
          Next
        </button>
      </div>
    </form>
  )
}